module.exports = "#define GLSLIFY 1\nuniform vec3 glowColor;\nuniform sampler2D lightningTexture;\nvarying float intensity;\nvarying vec2 vUv;\nuniform float offsetY;\nuniform float uTime;\n\nvoid main(){\n    vec2 uv = vUv;\n    uv.y += offsetY;\n\n  \tvec3 glow = glowColor * intensity;\n    vec3 color = vec3(step(0.1, uv.y) - step(0.2, uv.y)) - vec3(texture2D(lightningTexture, uv));\n\n\tfloat alpha = clamp(cos(uTime* 3.0) , 0.5, 1.0);\n\n    gl_FragColor = vec4( glow + color, alpha);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/shaders/xRay.frag
// module id = EYp+
// module chunks = 1